export function normalizeQuestionOptionsOrder(questionId = null, questionOptions = []) {
	if (!questionId || !Array.isArray(questionOptions) || questionOptions.length === 0) {
		return;
	}

	const { select, dispatch } = wp.data;
	const { getData } = select('learnpress/quiz');

	const userQuiz = getData();
	const questionsFromStore = userQuiz?.questions;

	const lpQuestions = window?.LP_QUIZ_SETTINGS?.questions;

	const updatedQuestionsForStore = lpQuestions.map(question => {
		const neddedQuestion = questionsFromStore.find(q => q.id === question.id);
		
		return {
			...question,
			options: question.options.map(option => {
				const neededOption = neddedQuestion.options.find(o => o.value === option.value);

				if ('isTrue' in neededOption) {
					return {...option, isTrue: neededOption.isTrue};
				}

				return option;
			})
		};
	});

	dispatch('learnpress/quiz').setQuizData({
		...userQuiz,
		questions: updatedQuestionsForStore,
	});
}
